"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.academyProgress = exports.ACADEMY_LESSON_IDS = void 0;
// J-314 (update 2, item 2c): the Learning Academy's saved progress, one row per (user, lesson). The
// Academy package (its README, "Contract with the portal") reads and writes it through
// `GET`/`PUT /api/v1/academy/progress`. It holds a lesson id, a scene position and a time: no patient data.
const drizzle_orm_1 = require("drizzle-orm");
const pg_core_1 = require("drizzle-orm/pg-core");
const schema_1 = require("./schema"); // Better Auth — never modified
/** The lessons the package saves progress for (`C.progressIds` in the package's `course.js`). */
exports.ACADEMY_LESSON_IDS = ["g1", "q1", "q2", "q3", "q4", "w1"];
exports.academyProgress = (0, pg_core_1.pgTable)("academy_progress", {
    // A user's own rows go with the user, as the access tables' do (`aco-access.ts`, `aco-group-access.ts`).
    userId: (0, pg_core_1.uuid)()
        .notNull()
        .references(() => schema_1.user.id, { onDelete: "cascade" }),
    lessonId: (0, pg_core_1.varchar)({ length: 8 }).notNull(),
    /** `<part index>:<scene index>`, at most 16 characters; null before the first scene is saved. */
    lastScene: (0, pg_core_1.varchar)({ length: 16 }),
    completedAt: (0, pg_core_1.timestamp)({ withTimezone: true }),
    updatedAt: (0, pg_core_1.timestamp)({ withTimezone: true }).notNull().defaultNow(),
}, (t) => [
    (0, pg_core_1.primaryKey)({ name: "academy_progress_pk", columns: [t.userId, t.lessonId] }),
    (0, pg_core_1.check)("academy_progress_lesson", (0, drizzle_orm_1.sql) `${t.lessonId} IN (${drizzle_orm_1.sql.raw(exports.ACADEMY_LESSON_IDS.map((id) => `'${id}'`).join(", "))})`),
    (0, pg_core_1.check)("academy_progress_scene", (0, drizzle_orm_1.sql) `${t.lastScene} IS NULL OR ${t.lastScene} ~ '^[0-9]+:[0-9]+$'`),
]);
//# sourceMappingURL=academy.js.map